import { IconArrow } from '../../../../../../assets/DesignSystem/SVGComponents';
import { NudosHoverText } from '../../../../../../components/NudosComponents';
import { IlogisticServiceLocation } from '../../../../../../types/services';
import { getLocationDisplayData } from '../../../../../../utils/locationIcons';
import './LogisticsOriginAndDestination.scss';

const LogisticsOriginAndDestination = ({
  origin,
  destination,
  className = '',
  originIconViewBox,
  destinationIconViewBox
}: {
  origin?: IlogisticServiceLocation | null;
  destination?: IlogisticServiceLocation | null;
  className?: string;
  originIconViewBox?: string;
  destinationIconViewBox?: string;
}) => {
  const noDataText = 'Sin datos';
  const originDisplayData = getLocationDisplayData(origin, { viewBox: originIconViewBox });
  const destinationDisplayData = getLocationDisplayData(destination, { viewBox: destinationIconViewBox });

  return (
    <div className={`LogisticsOriginAndDestination ${className}`}>
      <div className="origin">
        <div className="iconContainer">
          {originDisplayData.icon}
          <div className="flag" style={{ backgroundImage: originDisplayData.flag }} />
        </div>
        <NudosHoverText
          onlyIfTruncated
          customClassName="locationTitle"
          text={origin?.title || noDataText}
          charactersLimit={22}
        />
      </div>
      <IconArrow className="IconArrow" />
      <div className="destination">
        <div className="iconContainer">
          {destinationDisplayData.icon}
          <div className="flag" style={{ backgroundImage: destinationDisplayData.flag }} />
        </div>
        <NudosHoverText
          onlyIfTruncated
          customClassName="locationTitle"
          text={destination?.title || noDataText}
          charactersLimit={22}
        />
      </div>
    </div>
  );
};

export default LogisticsOriginAndDestination;
